import {Fragment} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconButton} from "@mui/material";
import {useBoolState, ConfirmDialog} from "@dvrt/graphql-widgets";
import {useDispatch} from "react-redux";
import {showNotification} from "../../../actions";
import {defineMessage} from "react-intl";
import {useDeleteGroupMembershipMutation} from "@/queries.generated";
import {CONFIRM_MESSAGES} from "@/utils/translations";

type Props = {
    groupId: number;
    numberId: number;
    onSuccess: () => void;
    name: string;
};

export default ({groupId, numberId, onSuccess, name}: Props) => {
    const [isDialogOpen, openDialog, closeDialog] = useBoolState();
    const [mutate] = useDeleteGroupMembershipMutation();
    const dispatch = useDispatch();

    async function handleDelete() {
        const response = await mutate({
            variables: {groupId, numberId},
        });

        if (response.data.deleteGroupMembership.length) {
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            );
            return;
        }

        dispatch(
            showNotification(
                defineMessage({id: "pickup_group_membership_deleted", defaultMessage: "User deleted"}),
                "success",
            ),
        );
        onSuccess();
    }

    return (
        <Fragment>
            <IconButton color="secondary" onClick={openDialog} size="small">
                <FontAwesomeIcon icon="trash" />
            </IconButton>
            <ConfirmDialog
                isOpen={isDialogOpen}
                close={closeDialog}
                onConfirm={handleDelete}
                message={CONFIRM_MESSAGES.general_delete}
                messageVars={{name}}
                buttonIdPrefix="delete-pickup-group-member"
            />
        </Fragment>
    );
};
